import React, { useState } from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import { useBuscarAgendamientosDeVenta } from "../../../services/agendamientosServicios";
import {
  buscarVenta,
  QUERY_BUSCAR_VENTA,
} from "../../../services/ventasServicios";
import { Venta } from "../../venta/Venta";
import { useParams } from "react-router-dom";
import LoadingScreen from "../../organisms/LoadingScreen";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { Row } from "react-bootstrap";
import PagarModal from "../../pagar/PagarModal";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/ventas",
    label: "Ventas",
  },
];

function MostrarVenta() {
  let { idVenta } = useParams();
  let queryClient = useQueryClient();

  const [mostrarPagarModal, setMostrarPagarModal] = useState<boolean>(false);

  const {
    data: agendamientos,
    isLoading: agendamientosIsLoading,
    isSuccess: agendamientosIsSuccess,
    isError: agendamientosIsError,
  } = useBuscarAgendamientosDeVenta(idVenta || "", idVenta !== undefined);

  const {
    data: venta,
    isLoading: ventaIsLoading,
    isError: ventaIsError,
  } = useQuery({
    queryKey: [QUERY_BUSCAR_VENTA],
    queryFn: async () => await buscarVenta(idVenta || ""),
    enabled: idVenta !== undefined,
  });

  const isError = agendamientosIsError || ventaIsError;

  const onPagarClick = () => {
    setMostrarPagarModal(true);
  };

  const onPagarModelCloseClick = () => {
    setMostrarPagarModal(false);
  };

  const onPagoSuccess = () => {
    queryClient.invalidateQueries([QUERY_BUSCAR_VENTA]);
    setMostrarPagarModal(false);
  };

  if (ventaIsLoading) {
    return <LoadingScreen />;
  }

  if (isError) {
    return <ServerErrorModal />;
  }

  return (
    <>
      <Page
        title="Visualizar Venta"
        description="Visualización y pago de venta."
        breadCrumbs={breadCrumbs}
      >
        {venta && (
          <Row className="justify-content-center">
            <div className="col-xs-12 col-md-12 col-lg-8 col-xxl-6">
              <Venta
                venta={venta}
                agendamientos={agendamientos}
                agendamientosIsLoading={agendamientosIsLoading}
                agendamientosIsSuccess={agendamientosIsSuccess}
                onPagarClick={onPagarClick}
              />
            </div>
          </Row>
        )}
      </Page>
      {mostrarPagarModal && venta && (
        <PagarModal
          venta={venta}
          onRegistrarPago={onPagoSuccess}
          onCloseClick={onPagarModelCloseClick}
        />
      )}
    </>
  );
}

export default MostrarVenta;
